module.exports = __webpack_public_path__ + "static/media/66860033-tyC0wSgs.49cf441d.JPG";